export const isPathSpecifyingDomain = (path: string): boolean => /^(?:[a-z]+:)?\/\//.test(path);

export const hasPathTraversal = (path: string): boolean => {
    const pathPortion = path.split('?')[0];
    return /%2f|%5c/i.test(pathPortion) || pathPortion.split('/').some((seg) => /^(?:%2e|\.){2}$/i.test(seg));
};

const hasNonLatin1Chars = (input: string): boolean => {
    for (const char of input) {
        if ((char.codePointAt(0) ?? 0) > 0xff) {
            return true;
        }
    }
    return false;
};

export const isValidAbsoluteHttpsUrl = (input: string): boolean => {
    if (
        !/^https:\/\//i.test(input) ||
        input.includes('\\') ||
        // eslint-disable-next-line no-control-regex
        /[\x00-\x1F\x7F]/.test(input) ||
        hasNonLatin1Chars(input)
    ) {
        return false;
    }

    try {
        const parsed = new URL(input);
        return parsed.protocol === 'https:' && !parsed.username && !parsed.password;
    } catch {
        return false;
    }
};

export const isValidPath = (path: unknown): path is string => {
    return (
        typeof path === 'string' &&
        path.startsWith('/') &&
        !path.startsWith('//') &&
        !path.includes('\\') && // Reject paths containing backslashes (common bypass attempt)
        !isPathSpecifyingDomain(path) &&
        !hasPathTraversal(path) &&
        // Node rejects non-Latin1 chars in Location header values (ERR_INVALID_CHAR)
        !hasNonLatin1Chars(path) &&
        // Reject paths containing ASCII control characters (0x00-0x1F, 0x7F)
        // This includes NUL bytes, tabs, newlines, etc.
        // eslint-disable-next-line no-control-regex
        !/[\x00-\x1F\x7F]/.test(path)
    );
};

// Validates and sanitizes a redirect target while allowing standard absolute https URLs.
export const getSafeRedirectPath = (input: unknown, fallback = '/'): string => {
    if (typeof input !== 'string' || !input) {
        return fallback;
    }

    if (isValidPath(input) || isValidAbsoluteHttpsUrl(input)) {
        return input;
    }

    try {
        const decoded = decodeURIComponent(input);
        if (isValidPath(decoded) || isValidAbsoluteHttpsUrl(decoded)) {
            return input;
        }
    } catch {}

    return fallback;
};

export const externalSourceQuery = 'e';
export const isExternalSourceSailthruEmail = (x: null | undefined | string | string[]): boolean => {
    if (!x) return false;
    if (Array.isArray(x)) {
        return x.some((y) => isExternalSourceSailthruEmail(y));
    }
    // ':' can legitimately live in query string unescaped
    // but if user goes through login flow, it will be escaped to '%3A' which is also valid. It just make detection harder
    // This is good enough
    return x.endsWith('sailthru');
};
export const fromLoginQuery = 'f'; // Track user coming landing from Login process
